<div [id]="id">
  @for (item of items; track item; let index = $index; let last = $last) {
    <input class="mb-2 form-control" [ngModel]="item" [placeholder]="placeholder" [required]="required" type="search"
           [ngModelOptions]="{'updateOn' : 'blur'}" [disabled]="disabled"
           (ngModelChange)="$event ? items[index] = $event : items.splice(index, 1); this.onModelChange()">
    @if (last) {
      <input class="mb-2 form-control" [ngModel]="null" placeholder="Add other"
             [disabled]="disabled" [ngModelOptions]="{'updateOn' : 'blur'}"
             (ngModelChange)="($event ? items.push($event) : null); this.onModelChange()">
    }
  }

  @if (items.length === 0) {
    <input class="form-control" [ngModel]="null" [placeholder]="items.length === 0 ? placeholder : 'Add other'"
           [disabled]="disabled" [required]="required" [ngModelOptions]="{'updateOn' : 'blur'}"
           (ngModelChange)="($event ? items.push($event) : null); this.onModelChange()">
  }
</div>

